
import { connect } from 'react-redux';
import { compose } from 'redux';

import PropTypes from 'prop-types';
import AccountApp from '../components/accounts/AccountApp';

import { withUserId } from './withUser';
import { withAllProducts } from './withAllProducts';

/**
 * Account page containers
 * Receives userId, loads products list, account, licences and invitations
 */

const mapDispatchToProps = (dispatch, { 
  fetchUserAccount,
  fetchAllProducts,
 }) => {
  return {
    loadData: _ => {
      fetchAllProducts();
      fetchUserAccount();
    }
  }
}

const AccountPageContainer = compose(
  withUserId,
  withAllProducts,
  connect(undefined, mapDispatchToProps)
)(
  AccountApp
)

AccountPageContainer.propTypes = {
  userId: PropTypes.string.isRequired
}

export default AccountPageContainer;


// WEBPACK FOOTER //
// ./src/containers/AccountApp.js